import React from 'react'
import WebMain from './WebMain'

/** 竖版宣传图，与 public/img/2025/h5/ 资源对应 */
const H5_IMAGES = [
    { src: '/img/home/home1.jpg', alt: '1' },
    { src: '/img/home/home2.jpg', alt: '2' },
    { src: '/img/home/home3.jpg', alt: '3' },
    { src: '/img/home/home4.jpg', alt: '4' },
    { src: '/img/home/home5.jpg', alt: '5' },
   
]

function H5Index() {
    return (
        <WebMain selectedKeys="product">
            <div style={{ display: 'flex', flexDirection: 'column', background: '#000' }}>
                {H5_IMAGES.map(({ src, alt }) => (
                    <img key={alt} src={src} alt={alt} style={{ width: '100%', display: 'block' }} />
                ))}
            </div>
        </WebMain>
    )
}

export default H5Index
